import { MapRE } from "@/game-eft/constants/constants.mjs";
import ExfilIcon from "@/inline-assets/eft-icon-extraction.svg";
import VisibilityOffIcon from "@/inline-assets/visibility-off.svg";

export const getExfilIconTemplate = (
  name: string,
  color: string,
  isSecret = false,
) =>
  `<div style="color:${color}">${isSecret ? `<div class="exfil-info">${VisibilityOffIcon.svg}</div>` : ""}${ExfilIcon.svg}<p>${name}</p></div>`;

export const MAP_ATTRIBUTION: Record<string, Record<string, string>> = {
  // Also covers MapRE.factory4_night
  [MapRE.factory4_day]: {
    _v2: "RE3MR.com, under CC-BY-NC-SA",
  },
  [MapRE.TarkovStreets]: {
    _v2: "/u/Jindouz",
  },
  // Also covers MapRE.Sandbox_high
  [MapRE.Sandbox]: {
    _v1: "xTycho",
  },
  [MapRE.Shoreline]: {
    _v3: "/u/Jindouz",
  },
};

export const WEBP_MAPS: Record<string, Record<string, boolean>> = {
  // Factory, also covers MapRE.factory4_night
  [MapRE.factory4_day]: {
    _v2: true,
    _v3: true,
  },
  // Ground Zero, also covers MapRE.Sandbox_high
  [MapRE.Sandbox]: {
    _v1: true,
    _v2: true,
  },
  // Streets
  [MapRE.TarkovStreets]: {
    _v2: true,
    _v3: true,
  },
  // Shoreline
  [MapRE.Shoreline]: {
    _v3: true,
    _v4: true,
  },
};

export const MAP_VERSIONS = {
  // Customs
  [MapRE.bigmap]: "_v2",
  // Factory
  [MapRE.factory4_day]: "_v3",
  // Ground Zero
  [MapRE.Sandbox]: "_v2",
  // Interchange
  [MapRE.Interchange]: "_v2",
  // Lighthouse
  [MapRE.Lighthouse]: "_v2",
  // Reserve
  [MapRE.RezervBase]: "_v2",
  // Shoreline
  [MapRE.Shoreline]: "_v4",
  // Streets
  [MapRE.TarkovStreets]: "_v3",
  // Labs
  [MapRE.laboratory]: "_v2",
  // Woods
  [MapRE.Woods]: "_v2",
};

export const mapCategories = [
  {
    name: "pmcExtract",
    label: ["eft:mapCategories.pmcExtract", "PMC Extractions"],
    color: "var(--green)",
    category: "Extractions",
  },
  {
    name: "scavExtract",
    label: ["eft:mapCategories.scavExtract", "Scav Extractions"],
    color: "var(--orange)",
    category: "Extractions",
  },
  {
    name: "sharedExtract",
    label: ["eft:mapCategories.sharedExtract", "Shared Extractions"],
    color: "var(--turq)",
    category: "Extractions",
  },
  {
    name: "transitExtract",
    label: ["eft:transits", "Transits"],
    color: "var(--purple)",
    category: "Extractions",
  },
] as const;

export default mapCategories;
